// @flow
import React from 'react';
import MessageBox from '../../common/components/core/MessageBox';

import { SUPPORT_EMAIL_HREF } from '../support/constants';
import { Link } from '../../common/components/core';

type Props = {
  hide: boolean,
  className?: string
};

class TextMeTheAppWarningBanner extends React.Component<Props> {
  render() {
    return (
      <MessageBox
        type="warning"
        title="Warning"
        hide={this.props.hide}
        className={this.props.className}
        text={
          <div>
            Our Text Me The App (TMTA) and SMS functionality is disabled by
            default and must be enabled manually by our team.
            <br />
            Please reach out to{' '}
            <Link testid="email-branch-support" href={SUPPORT_EMAIL_HREF}>
              support@branch.io
            </Link>{' '}
            if you would like to use this feature. Check out our{' '}
            <Link
              testid="tmta-help-branch"
              href={'https://help.branch.io/using-branch/docs/text-me-the-app'}
            >
              docs
            </Link>{' '}
            for more info.
          </div>
        }
      />
    );
  }
}

export default TextMeTheAppWarningBanner;
